module.exports = __webpack_public_path__ + "static/media/otherportfolio.884cb1f3.png";